import { PaletteMode } from '@mui/material';
import { ChronosphereColorPalette, green } from '../colors';
import { GetThemeOptions } from '../../theme';
import { unityDarkTokens, unityLightTokens } from '@/theme/unityTokens';

export const primaryColor = (mode: PaletteMode, opts: GetThemeOptions): ChronosphereColorPalette => {
  if (opts.panwRebrandStubYear) {
    return mode === 'light'
      ? {
          main: unityLightTokens['--primary-color-main'],
          highContrast: unityLightTokens['--primary-color-high-contrast'],
          lowContrast: unityLightTokens['--primary-color-low-contrast'],
        }
      : {
          main: unityDarkTokens['--primary-color-main'],
          highContrast: unityDarkTokens['--primary-color-high-contrast'],
          lowContrast: unityDarkTokens['--primary-color-low-contrast'],
        };
  }

  return mode === 'light'
    ? {
        main: green[600],
        highContrast: green[800],
        lowContrast: green[150],
      }
    : {
        main: green[500],
        highContrast: green[300],
        lowContrast: green[700],
      };
};
